function copiarEnlace(btn) {
  const enlace = btn?.dataset?.url || window.location.href;

  navigator.clipboard.writeText(enlace)
    .then(() => {
      const mensaje = document.getElementById('copy-message');
      if (mensaje) {
        const original = mensaje.textContent;
        mensaje.textContent = '¡Enlace copiado!';
        mensaje.style.display = 'inline';
        setTimeout(() => {
          mensaje.textContent = original;
          mensaje.style.display = 'none';
        }, 2000);
      }
    })
    .catch(err => {
      console.error('Error al copiar el enlace:', err);
    });
}
